import {
  SHOW_CHANGE_WORKSPACE_PLAN_CONFIRM,
  HIDE_CHANGE_WORKSPACE_PLAN_CONFIRM,
  SHOW_DELETE_WORKSPACE_CONFIRM,
  HIDE_DELETE_WORKSPACE_CONFIRM,
  CHANGE_WORKSPACE_PLAN_MIGRATION_STEP,
  CLEAR_WORKSPACE_PLAN_MIGRATION
} from 'actions'

const initialState = {
  isShowingChangePlanConfirm: false,
  isShowingDeleteWorkspaceConfirm: false,
  nextPlanId: null,
  migrationStep: 'checks'
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SHOW_CHANGE_WORKSPACE_PLAN_CONFIRM:
      return {
        ...state,
        nextPlanId: payload,
        isShowingChangePlanConfirm: true
      }
    case HIDE_CHANGE_WORKSPACE_PLAN_CONFIRM:
      return {
        ...state,
        nextPlanId: null,
        isShowingChangePlanConfirm: false
      }
    case SHOW_DELETE_WORKSPACE_CONFIRM:
      return {
        ...state,
        isShowingDeleteWorkspaceConfirm: true
      }
    case HIDE_DELETE_WORKSPACE_CONFIRM:
      return {
        ...state,
        isShowingDeleteWorkspaceConfirm: false
      }
    case CHANGE_WORKSPACE_PLAN_MIGRATION_STEP:
      return {
        ...state,
        migrationStep: payload
      }
    case CLEAR_WORKSPACE_PLAN_MIGRATION:
      return {
        ...initialState
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/workspace-settings.js